import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// "2026 08 26" (canonico) o "08/26/2026" (vecchi dati produzione MM/DD/YYYY) -> "26/08/2026"
export function formatDateIT(dateUs) {
  if (!dateUs) return "";
  if (dateUs.includes(" ")) {
    const [y, m, d] = dateUs.split(" ");
    return `${d}/${m}/${y}`;
  }
  const parts = dateUs.split("/");
  if (parts.length === 3) {
    const [a, b, y] = parts;
    const [m, d] = Number(a) > 12 ? [b, a] : [a, b];
    return `${d}/${m}/${y}`;
  }
  return dateUs;
}
